<template>
  <span v-if="value" class="copy-text" :class="{ 'is-truncated': truncate }"
        :style="truncate ? { maxWidth } : null"
        :title="`${value}\nClick to copy`" @click.stop="copy">
    <code v-if="mono" class="copy-value id-code">{{ value }}</code>
    <span v-else class="copy-value">{{ value }}</span>
    <b-icon class="copy-icon" icon="content-copy" size="is-small" />
  </span>
  <span v-else class="copy-empty">—</span>
</template>

<script>
import { copyToClipboard } from '@/helpers/clipboard'

export default {
  name: 'CopyText',
  props: {
    value: { type: String, default: '' },
    // Used in the "<label> copied" confirmation
    label: { type: String, default: 'Value' },
    mono: { type: Boolean, default: false },
    // Clip to `maxWidth` rather than wrapping — for table cells, where an
    // over-long value would otherwise stretch the column
    truncate: { type: Boolean, default: false },
    maxWidth: { type: String, default: '100%' }
  },
  methods: {
    async copy() {
      await copyToClipboard(this.value)
      this.$buefy.toast.open({ type: 'is-success', message: `${this.label} copied` })
    }
  }
}
</script>

<style scoped>
.copy-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  cursor: pointer;
}

.copy-value {
  overflow: hidden;
  text-overflow: ellipsis;
}

.is-truncated .copy-value {
  white-space: nowrap;
}

.copy-icon {
  flex-shrink: 0;
  color: var(--text-muted);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.copy-text:hover .copy-icon {
  opacity: 1;
}

.copy-text:hover .copy-value {
  color: var(--feeds-green, #00857a);
}

.copy-empty {
  color: var(--text-muted);
}

.id-code {
  background-color: var(--bg-tertiary);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.85em;
  color: var(--text-secondary);
}
</style>
